import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { ShipmentLoadOverview } from '../../models/shipment-load.model';
import { ShipmentLoadMainInfoService } from './shipment-load-main-info.service';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { Error, CustomHttpErrorResponse } from '../../../../../common';
import { ShipmentLoadOverviewLoad, ShipmentLoadOverviewSetInitialState } from './shipment-load-main-info.actions';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface ShipmentLoadOverviewStateModel {
  overview: ShipmentLoadOverview;
  loaded: boolean;
}

const initialState: ShipmentLoadOverviewStateModel = {
  overview: null,
  loaded: false,
};

@State<ShipmentLoadOverviewStateModel>({
  name: 'shipmentLoadOverview',
  defaults: initialState,
})
@Injectable()
export class ShipmentLoadMainInfoState {
  constructor(
    private shipmentLoadOverviewService: ShipmentLoadMainInfoService,
    private notificationService: NotificationService,
  ) {}
  @Selector()
  static getLoaded(state: ShipmentLoadOverviewStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getOverview(state: ShipmentLoadOverviewStateModel): ShipmentLoadOverview {
    return state.overview;
  }

  @Selector()
  static getCanceledStatus(state: ShipmentLoadOverviewStateModel): boolean {
    return state.overview.cancelled;
  }

  @Action(ShipmentLoadOverviewLoad)
  getWaybillOverview(
    ctx: StateContext<ShipmentLoadOverviewStateModel>,
    { payload }: ShipmentLoadOverviewLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.shipmentLoadOverviewService.getOverviewData(payload).pipe(
      map((overview: ShipmentLoadOverview) => {
        ctx.patchState({ overview, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ShipmentLoadOverviewSetInitialState)
  setInitialState(ctx: StateContext<ShipmentLoadOverviewStateModel>): void {
    ctx.setState(initialState);
  }
}
